import { Fragment, useEffect, useState, useMemo, useRef, useCallback } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { closePageTabByKey } from '@/hooks/useSyncedPageTabs';
// import { LeftOutlined, UploadOutlined, PaperClipOutlined, DeleteOutlined, ArrowUpOutlined, ArrowDownOutlined, PlusCircleOutlined, CloseOutlined } from '@ant-design/icons';
import './Invitation.less';
import { Form, Input, Layout, DatePicker, Radio, Checkbox, Space, Button, Select, Switch, Upload, Col, Row, message, Image, Typography } from 'antd';
import { fileApi, getUserFieldsApi, saveInvitationApi, getInvitationOneApi, updateInvitationOneApi } from '@services/Invitation/Invitation';
import { pageFormItemLayout, pageFormItemWithoutLabelGridLayout } from '../../utils/property';
import { getMaxFileWidthAndHeight } from '../../utils/utils';
import dayjs from 'dayjs';
import { isEmpty } from '@utils/utils';
import config from '@config';
import ImgCrop from 'antd-img-crop';
import PopoverTip from '../common/PopoverTip';
import RichEditor, { isEffectivelyEmptyRichHtml } from '@components/common/RichEditor';
import PageHeader from '@components/PageHeader/PageHeader';
const { RangePicker } = DatePicker;
const { Text } = Typography;

/**
 * 个人信息字段：两组分区标题 + 两个 Checkbox.Group，合并为单一 userFields 数组供表单提交。
 */
function UserFieldsCheckboxGroups({ value = [], onChange, baseList: bl, moreList: ml }) {
    const baseOrder = (bl || []).map(b => b.fieldName);
    const moreOrder = (ml || []).map(m => m.fieldName);

    const baseValue = baseOrder.filter(fn => value.includes(fn));
    const moreValue = moreOrder.filter(fn => value.includes(fn));

    const handleBaseChange = vals => {
        const fromMore = moreOrder.filter(fn => value.includes(fn));
        const sortedBase = baseOrder.filter(fn => vals.includes(fn));
        onChange?.([...sortedBase, ...fromMore]);
    };
    const handleMoreChange = vals => {
        const fromBase = baseOrder.filter(fn => value.includes(fn));
        const sortedMore = moreOrder.filter(fn => vals.includes(fn));
        onChange?.([...fromBase, ...sortedMore]);
    };

    return (
        <div>
            {baseOrder.length > 0 && (
                <div className="field-group">
                    <div className="field-title">基本信息</div>
                    <Checkbox.Group style={{ width: '100%' }} options={(bl || []).map(base => ({ label: base.displayName, value: base.fieldName }))} value={baseValue} onChange={handleBaseChange} />
                </div>
            )}
            {moreOrder.length > 0 && (
                <div className="field-group">
                    <div className="field-title">更多信息</div>
                    <Checkbox.Group style={{ width: '100%' }} options={(ml || []).map(more => ({ label: more.displayName, value: more.fieldName }))} value={moreValue} onChange={handleMoreChange} />
                </div>
            )}
        </div>
    );
}

export default function Invitation() {
    const navigate = useNavigate();
    const location = useLocation();

    const params = useParams();
    const gid = params?.gid || 0;
    const id = params?.id || 0;

    const [form] = Form.useForm();

    const [invitationType, setInvitationType] = useState(3);
    const [oneData, setOneData] = useState({});
    const [bossList, setBossList] = useState([]);
    const [baseList, setBaseList] = useState([]);
    const [moreList, setMoreList] = useState([]);
    const [prodDetails, setProdDetails] = useState(undefined);
    const [topProdDetails, setTopProdDetails] = useState(undefined);
    const [onConfirmPersonalInfoSwitch, setOnConfirmPersonalInfoSwitch] = useState(false);
    const [onEnableTipsSwitch, setOnEnableTipsSwitchChange] = useState(false);
    const [onEnableContentSwitch, setOnEnableContentSwitchChange] = useState(false);
    const [onEnableLaborSwitch, setOnEnableLaborSwitchChange] = useState(false);
    const [onEnableContactsSwitch, setOnEnableContactsSwitchChange] = useState(false);
    const [onRightFormSwitch, setOnRightFormSwitch] = useState(false);
    const [onCocreationFormSwitch, setOnCocreationFormSwitch] = useState(false);

    const [fileList, setFileList] = useState([]);
    const option = { headers: { 'Content-Type': 'multipart/form-data' } };

    const [textAreaValue, setTextAreaValue] = useState('');
    const textAreaRef = useRef();
    const timeOutRef = useRef(null);

    const inputTimeOutRef = useRef(null);
    const inputShareTitleRef = useRef(null);
    const [shareTitle, setShareTitle] = useState('');

    // 文件上传
    //前缀
    const getFileUrl = url => {
        if (url && url.includes('https')) {
            return url;
        }
        if (url && !url.includes('https')) {
            return config.OSS_PREFIX + url;
        }
        return null;
    };

    /** antd Form + Upload：从 onChange 事件取 fileList */
    const normFile = e => {
        if (Array.isArray(e)) {
            return e;
        }
        return e?.fileList ?? [];
    };

    /** 接口路径或完整 URL 转为 Upload 受控 fileList（antd 6 不再使用 value） */
    const pathToUploadFileList = (value, uidPrefix) => {
        if (!value) {
            return [];
        }
        const isHttp = typeof value === 'string' && value.startsWith('http');
        const url = isHttp ? value : getFileUrl(value);
        return [
            {
                uid: `-${uidPrefix}`,
                name: 'image',
                status: 'done',
                url,
                response: value,
            },
        ];
    };

    /** 提交时从 fileList 或兼容旧字符串取出后端字段 */
    const uploadValueToSubmitString = v => {
        if (v == null || v === '') {
            return '';
        }
        if (typeof v === 'string') {
            return v;
        }
        if (Array.isArray(v) && v[0]) {
            const f = v[0];
            if (typeof f.response === 'string') {
                return f.response;
            }
            return '';
        }
        return '';
    };

    const uploadImageRequiredRules = [
        {
            validator: async (_, v) => {
                if (!v || (Array.isArray(v) && v.length === 0)) {
                    return Promise.reject(new Error(''));
                }
                return Promise.resolve();
            },
        },
    ];
    // 校验文件格式
    const checkout = (file, size, initWidth, initHeight) => {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg';
        // 判断类型
        if (!isJpgOrPng) {
            message.error('只能上传 jpg/png/jpeg 格式');
        }
        // 判断大小
        const isLt2M = file.size / 1024 / 1024 < size;
        if (!isLt2M) {
            message.error('图像必须小于' + size + 'MB!');
        }
        return isJpgOrPng && isLt2M;
    };

    //pdf校验格式
    const fileCheck = (file, size) => {
        const isPdf = file.type === 'application/pdf' || file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg';
        if (!isPdf) {
            message.error('请上传 JPG/PNG/PDF 格式附件');
        }
        const isLt5M = file.size / 1024 / 1024 < size;
        if (!isLt5M) {
            message.error('请上传' + size + 'MB以内的附件!');
        }
        return isPdf && isLt5M;
    };

    // 分享图
    const shareImageFile = {
        name: 'shareImageFile',
        onChange(info) {
            if (info.file.status === 'uploading') {
                info.file.status = 'done';
            }
        },
        customRequest: info => {
            const formData = new FormData();
            formData.append('file', info.file); //名字和后端接口名字对应
            formData.append('type', 15);
            fileApi(formData, option).then(res => {
                if (!res) {
                    message.error('上传文件失败！！');
                    return false;
                }
                if (res.status_code === 200) {
                    setOneData({ ...oneData, shareImage: getFileUrl(res.data) });
                    form.setFieldValue('shareImage', [
                        {
                            uid: String(info.file.uid),
                            name: info.file.name,
                            status: 'done',
                            url: getFileUrl(res.data),
                            response: res.data,
                        },
                    ]);
                }
            });
        },
    };

    const coverForListFile = {
        name: 'coverForListFile',
        onChange(info) {
            if (info.file.status === 'uploading') {
                info.file.status = 'done';
            }
        },
        customRequest: info => {
            const formData = new FormData();
            formData.append('file', info.file); //名字和后端接口名字对应
            formData.append('type', 15);
            fileApi(formData, option).then(res => {
                if (!res) {
                    message.error('上传文件失败！！');
                    return false;
                }
                if (res.status_code === 200) {
                    const fullUrl = getFileUrl(res.data);
                    setOneData({ ...oneData, coverForList: fullUrl });
                    form.setFieldValue('coverForList', [
                        {
                            uid: String(info.file.uid),
                            name: info.file.name,
                            status: 'done',
                            url: fullUrl,
                            response: fullUrl,
                        },
                    ]);
                }
            });
        },
    };

    // H5封面
    const h5CoverFile = {
        name: 'h5CoverFile',
        onChange(info) {
            if (info.file.status === 'uploading') {
                info.file.status = 'done';
            }
        },
        customRequest: info => {
            const formData = new FormData();
            formData.append('file', info.file); //名字和后端接口名字对应
            formData.append('type', 15);
            fileApi(formData, option).then(res => {
                if (!res) {
                    message.error('上传文件失败！！');
                    return false;
                }
                if (res.status_code === 200) {
                    setOneData({ ...oneData, h5CoverUrl: getFileUrl(res.data) });
                    form.setFieldValue('h5Cover', [
                        {
                            uid: String(info.file.uid),
                            name: info.file.name,
                            status: 'done',
                            url: getFileUrl(res.data),
                            response: res.data,
                        },
                    ]);
                }
            });
        },
    };

    // 顶部背景图
    const backgroundImageFile = {
        name: 'backgroundImageFile',
        onChange(info) {
            if (info.file.status === 'uploading') {
                info.file.status = 'done';
            }
        },
        customRequest: info => {
            const formData = new FormData();
            formData.append('file', info.file); //名字和后端接口名字对应
            formData.append('type', 15);
            fileApi(formData, option).then(res => {
                if (!res) {
                    message.error('上传文件失败！！');
                    return false;
                }
                if (res.status_code === 200) {
                    setOneData({ ...oneData, backgroundImage: getFileUrl(res.data) });
                    form.setFieldValue('backgroundImage', [
                        {
                            uid: String(info.file.uid),
                            name: info.file.name,
                            status: 'done',
                            url: getFileUrl(res.data),
                            response: res.data,
                        },
                    ]);
                }
            });
        },
    };

    // 删除邀请函背景
    const closeImg = () => {
        const newItem = { ...oneData };
        delete newItem.backgroundImage;
        setOneData(newItem);
        form.setFieldValue('backgroundImage', []);
    };

    const pdfFile = {
        name: 'pdfFile',
        onChange(info) {
            if (info.file.status === 'uploading') {
                info.file.status = 'done';
            }
        },
        customRequest: info => {
            const formData = new FormData();
            formData.append('file', info.file);
            formData.append('type', 16);
            fileApi(formData, option).then(res => {
                if (!res) {
                    message.error('上传文件失败！！');
                    return false;
                }
                if (res.status_code === 200) {
                    const obj = {
                        path: res.data,
                        name: info.file.name,
                    };
                    setFileList([...fileList, obj]);
                }
            });
        },
    };

    useEffect(() => {
        if (fileList.length > 0) {
            fileList.map((item, index) => {
                form.setFieldValue(['attachments', `path${index}`], item.path);
                form.setFieldValue(['attachments', `name${index}`], item.name);
            });
        }
    }, [fileList]);

    const onProdDetailsChange = v => {
        setProdDetails(v);
    };

    const onTopProdDetailsChange = v => {
        setTopProdDetails(v);
    };

    // 新增邀请函
    const onFinish = values => {
        // console.log(values);
        // return;

        if (values.rightFormEnabled) {
            const arr = (values.rightForm || []).filter(item => item.check);
            if (isEmpty(arr)) {
                return message.error('请至少勾选一项权益形式！');
            }
        }
        if (values.cocreationForm) {
            const arr = (values.cocreationForm || []).filter(item => item.check);
            if (isEmpty(arr)) {
                return message.error('请至少勾选一项意向选项！');
            }
        }

        // 落款数据处理
        let signature = {
            sigs: [],
            date: undefined,
        };
        if (!!values?.signature?.date) {
            signature.date = values.signature.date;
        }
        if (!!values?.signature?.sigs?.length) {
            values.signature.sigs.forEach(s => {
                s = s?.replace(/(^[ 　]+)|([ 　]+$)/g, ''); // 去除空格
                if (!!s) {
                    signature.sigs.push(s);
                }
            });
        }
        signature = JSON.stringify(signature);

        const infoList = [];
        if (values.confirmPersonalInfo) infoList.push(...values.userFields);
        if (values.laborEnabled) infoList.push(...values.laborFields);
        const dto = {
            name: values.name,
            remarks: values.remarks,
            // type: values.direct,
            type: 3,
            startTime: dayjs(values.expiration[0]).format('YYYY-MM-DD 00:00:00'),
            endTime: dayjs(values.expiration[1]).format('YYYY-MM-DD 23:59:59'),
            nameTitle: values.userTitle,
            contentEnabled: values.contentEnabled ? 1 : 0,
            content: values.invitationContent,
            agendaEnabled: values.agenda ? 1 : 0,
            unconfirmedExpertHidden: values.unconfirmedExpertDisplayStatus ? 0 : 1, // 待确认邀请专家，hidden=0 为显示
            laborEnabled: values.laborEnabled ? 1 : 0,
            userInfoEnabled: values.confirmPersonalInfo ? 1 : 0,
            userFieldList: infoList,
            contactsEnabled: values.contactsEnabled ? 1 : 0,
            contactInfos: JSON.stringify(values.contactInfos),
            tipsEnabled: values.enableTips ? 1 : 0,
            tips: values.tips,
            shareTitle: values.shareTitle,
            shareDescription: values.shareDesc,
            shareImage: uploadValueToSubmitString(values.shareImage),
            coverForList: uploadValueToSubmitString(values.coverForList),
            // pcCoverUrl: values?.pcCover,
            h5CoverUrl: uploadValueToSubmitString(values?.h5Cover),
            // pcBannerUrl: values.pcBanner,
            // h5BannerUrl: values.h5Banner,
            backgroundImage: uploadValueToSubmitString(values.backgroundImage) || '',
            groupId: gid,
            attachments: fileList ? JSON.stringify(fileList) : '',
            smsInfo: values.invitationDesc,
            projectCardEnabled: values.projectCardEnabled ? 1 : 0,
            rightFormEnabled: values.rightFormEnabled ? 1 : 0,
            // antd v6 onFinish 不包含 Form.List 未注册子项（如 id），从 store 取完整值
            rightForm: JSON.stringify(form.getFieldValue('rightForm')),
            cocreationFormEnabled: values.cocreationFormEnabled ? 1 : 0,
            cocreationForm: JSON.stringify(form.getFieldValue('cocreationForm')),
            signature,
        };
        console.log('dto', dto);
        // return;

        if (!!id) {
            dto.id = id;
            updateInvitationOneApi(dto).then(res => {
                if (res.status_code === 200) {
                    message.success(res.message);
                    navigate('/invitation/g/' + gid + '/invitations');
                }
            });
        } else {
            saveInvitationApi(dto).then(res => {
                if (res.status_code === 200) {
                    message.success(res.message);
                    navigate('/invitation/g/' + gid + '/invitations');
                }
            });
        }
    };

    const onReset = () => {
        const currentKey = location.pathname;
        navigate('/invitation/g/' + gid + '/invitations');
        closePageTabByKey(currentKey);
    };

    const imageUploadHandler = useCallback(
        async blobInfo => {
            const formData = new FormData();
            formData.append('file', blobInfo.blob());
            formData.append('type', 15);
            const hide = message.loading('上传中...', 0);
            try {
                const res = await fileApi(formData, option);
                const url = getFileUrl(res.data);
                hide();
                return url;
            } catch (e) {
                hide();
                throw e;
            }
        },
        [getFileUrl, option],
    );

    useEffect(() => {
        getUserFieldsApi({}).then(res => {
            if (res.status_code === 200) {
                setBaseList(res.data.basic);
                setBossList(res.data.labour);
                setMoreList(res.data.more);
            }
        });

        const arr = [
            { id: 1, check: false, name: '劳务费' },
            { id: 2, check: false, name: '' },
            { id: 3, check: false, name: '' },
            { id: 4, check: false, name: '' },
            { id: 5, check: false, name: '' },
        ];

        const arr1 = [
            { id: 1, check: false, name: '' },
            { id: 2, check: false, name: '' },
            { id: 3, check: false, name: '' },
            { id: 4, check: false, name: '' },
            { id: 5, check: false, name: '' },
        ];

        if (!id) {
            // form.setFieldValue('direct', invitationType);
            form.setFieldValue('contentEnabled', true);
            form.setFieldValue('projectCardEnabled', true);
            setOnEnableContentSwitchChange(true);
            form.setFieldValue('rightForm', arr);
            form.setFieldValue('cocreationForm', arr1);
        }
        if (!!id) {
            getInvitationOneApi({ id }).then(res => {
                if (res.status_code === 200) {
                    console.log(res.data);
                    setOneData(res.data);

                    const pdfList =
                        res.data.attachments === ''
                            ? []
                            : JSON.parse(res.data.attachments).map(item => {
                                  return {
                                      ...item,
                                      path: getFileUrl(item.path),
                                  };
                              });

                    setFileList(res.data.attachments ? [...pdfList] : []);
                    const list = res.data.userFieldList.filter(i => {
                        return i !== 'bankName' && i !== 'bankCardNo' && i !== 'idCard' && i !== 'electronSign';
                    });

                    // 落款数据处理
                    const signature = {
                        sigs: [],
                        date: undefined,
                    };
                    if (res.data.signature) {
                        const sigObj = JSON.parse(res.data.signature) || {};

                        if (!isEmpty(sigObj)) {
                            if (sigObj?.sigs && sigObj.sigs.length) {
                                signature.sigs = sigObj.sigs;
                            }
                            if (!!sigObj?.date) {
                                signature.date = sigObj.date;
                            }
                        }
                    }

                    form.setFieldsValue({
                        name: res.data.name,
                        remarks: res.data.remarks,
                        direct: res.data.type,
                        expiration: [dayjs(res.data.startTime), dayjs(res.data.endTime)],
                        userTitle: res.data.nameTitle,
                        contentEnabled: res.data.contentEnabled,
                        invitationContent: res.data.content,
                        agenda: res.data.agendaEnabled,
                        unconfirmedExpertDisplayStatus: !res.data.unconfirmedExpertHidden,
                        laborEnabled: res.data.laborEnabled,
                        laborFields: ['bankName', 'bankCardNo', 'idCard', 'electronSign'],
                        confirmPersonalInfo: res.data.userInfoEnabled,
                        userFields: list,
                        contactsEnabled: res.data.contactsEnabled,
                        contactInfos: res.data.contactInfos ? JSON?.parse(res.data.contactInfos) : [{}],
                        enableTips: res.data.tipsEnabled,
                        tips: res.data.tips,
                        shareTitle: res.data.shareTitle,
                        shareDesc: res.data.shareDescription,
                        shareImage: pathToUploadFileList(res.data.shareImage, 'share'),
                        coverForList: pathToUploadFileList(res.data.coverForList, 'cover'),
                        backgroundImage: pathToUploadFileList(res.data.backgroundImage, 'bg'),
                        invitationDesc: res.data.smsInfo,
                        projectCardEnabled: res.data.projectCardEnabled,
                        h5Cover: pathToUploadFileList(res.data?.h5CoverUrl, 'h5'),
                        rightFormEnabled: res?.data?.rightFormEnabled,
                        rightForm: res.data?.rightForm === null ? arr : JSON?.parse(res.data.rightForm),
                        cocreationFormEnabled: res?.data?.cocreationFormEnabled,
                        cocreationForm: res.data?.cocreationForm === null ? arr1 : JSON.parse(res?.data?.cocreationForm),
                        signature,
                    });

                    setTextAreaValue(res.data.smsInfo);
                    setInvitationType(res.data.type);
                }
            });
        }

        return () => {
            if (timeOutRef.current) {
                clearTimeout(timeOutRef.current);
            }
        };
    }, []);

    const onConfirmPersonalInfoSwitchChange = value => {
        setOnConfirmPersonalInfoSwitch(value);
        setOneData({ ...oneData, userInfoEnabled: value ? 1 : 0 });
    };

    const onEnableTipsSwitchChange = value => {
        setOnEnableTipsSwitchChange(value);
        setOneData({ ...oneData, tipsEnabled: value ? 1 : 0 });
    };

    const onEnableContentSwitchChange = value => {
        setOnEnableContentSwitchChange(value);
        setOneData({ ...oneData, contentEnabled: value ? 1 : 0 });
    };

    const onLaborEnabledSwitchChange = value => {
        setOnEnableLaborSwitchChange(value);
        setOneData({ ...oneData, laborEnabled: value ? 1 : 0 });
    };

    const onContactsEnabledSwitchChange = value => {
        setOnEnableContactsSwitchChange(value);
        setOneData({ ...oneData, contactsEnabled: value ? 1 : 0 });
    };

    const onRightFormEnabledSwitchChange = value => {
        setOnRightFormSwitch(value);
        setOneData({ ...oneData, rightFormEnabled: value ? 1 : 0 });
    };

    const onCocreationFormEnabledSwitchChange = value => {
        setOnCocreationFormSwitch(value);
        setOneData({ ...oneData, cocreationFormEnabled: value ? 1 : 0 });
    };

    const changeFileName = (e, index) => {
        const olidFile = [...fileList];
        olidFile[index].name = e.target.value;
        setFileList([...olidFile]);
    };

    const changeFile = (index, type) => {
        const olidFile = [...fileList];
        const currentFile = olidFile[index];
        if (type === 'del') {
            olidFile.splice(index, 1);
            setFileList([...olidFile]);
        } else if (type === 'up') {
            const preFile = olidFile[index - 1];
            let midSave;
            midSave = currentFile;
            olidFile[index] = preFile;
            olidFile[index - 1] = midSave;
            setFileList([...olidFile]);
        } else if (type === 'down') {
            const nextFile = olidFile[index + 1];
            let midSave;
            midSave = currentFile;
            olidFile[index] = nextFile;
            olidFile[index + 1] = midSave;
            setFileList([...olidFile]);
        }
    };

    const handleTextAreaChange = e => {
        setTextAreaValue(e?.target?.value);
        form.setFieldValue('invitationDesc', e?.target?.value);
    };

    // 获取光标位置
    const getPositionForInput = ctrl => {
        const caretPos = { start: 0, end: 0 };
        if (ctrl.selectionStart) {
            caretPos.start = ctrl.selectionStart;
        }
        if (ctrl.selectionEnd) {
            caretPos.end = ctrl.selectionEnd;
        }
        return caretPos;
    };

    // 设置光标位置
    const setCursorPosition = (ctrl, start, end) => {
        ctrl.focus();
        ctrl.setSelectionRange(start, end);
    };

    // 插入信息
    const handleInsert = () => {
        const txt = '$邀请链接$';
        if (textAreaValue?.length + txt.length > 500) {
            message.warning('文本长度不能超过500字符');
            return;
        }

        if (!textAreaRef.current) {
            message.warning('请先点击输入框');
            return;
        }

        const textarea = textAreaRef.current.resizableTextArea?.textArea;
        if (!textarea) {
            message.warning('无法获取输入框元素');
            return;
        }

        const position = getPositionForInput(textarea);
        const insertStart = position.start;
        const insertEnd = insertStart + txt.length;
        // 如果有选中文本，替换选中部分；否则在光标位置插入
        const newText = textAreaValue.slice(0, insertStart) + txt + textAreaValue.slice(position.end);

        setTextAreaValue(newText);
        form.setFieldValue('invitationDesc', newText);

        timeOutRef.current = setTimeout(() => {
            setCursorPosition(textarea, insertEnd, insertEnd);
        }, 100);
    };

    const insertNameTitleToShareTitle = () => {
        const txt = '$姓名称谓$';

        const input = inputShareTitleRef.current.input;
        const position = getPositionForInput(input);
        const insertStart = position.start;
        const insertEnd = position.end + txt.length;
        const newText = shareTitle.slice(0, insertStart) + txt + shareTitle.slice(insertStart);
        console.log(newText);
        inputTimeOutRef.current = setTimeout(() => {
            setCursorPosition(input, insertStart, insertEnd);
        }, 200);

        setShareTitle(newText);
        form.setFieldValue('shareTitle', newText);
    };

    const changeShareTitle = e => {
        console.log(e.target.value);
        setShareTitle(e.target.value);
        form.setFieldValue('shareTitle', e.target.value);
    };

    const beforeCropCheck = (file, bool) => {
        if (file.type !== 'image/png' && file.type !== 'image/jpg' && file.type !== 'image/jpeg') {
            message.error('只支持JPG/JPEG/PNG格式。');
            return null;
        }

        if (file.size > 1 * 1024 * 1024) {
            message.error('图片大小不能超过1MB。');
            return null;
        }

        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = event => {
                const res = event.target.result;
                const imgDom = document.createElement('img');
                imgDom.src = res;
                imgDom.onload = () => {
                    resolve(true);
                };
            };
            reader.readAsDataURL(file);
        });
    };

    useEffect(() => {
        document.title = id ? '编辑邀请函-' : '新增邀请函';
    }, [id]);

    return (
        <Fragment>
            <PageHeader
                title={
                    <>
                        <i className="bi bi-chevron-left page-header-back-btn" onClick={() => navigate(`/invitation/g/${gid}/invitations`)} />
                        <span>{!id ? '新增邀请函' : '编辑邀请函'}</span>
                    </>
                }
                breadcrumb={[{ label: '邀请组管理', path: '/invitation/groups' }, { label: '邀请函管理', path: `/invitation/g/${gid}/invitations` }, { label: !id ? '新增邀请函' : '编辑邀请函' }]}
            />

            <div className="page-route-body">
                <Form
                    className="page-form projects-form"
                    {...pageFormItemLayout}
                    form={form}
                    onFinish={onFinish}
                    initialValues={{
                        // contentEnabled: true,
                        userTitle: 6,
                        laborFields: ['bankName', 'bankCardNo', 'idCard', 'electronSign'],
                        contactInfos: [{}],
                        agenda: 1,
                        unconfirmedExpertDisplayStatus: 1,
                    }}
                >
                    <div className="form-subtitle">基本信息</div>

                    <Form.Item name="name" label="邀请函名称" rules={[{ required: true, message: '' }]}>
                        <Input placeholder="输入邀请函名称" allowClear />
                    </Form.Item>

                    <Form.Item name="remarks" label="备注信息">
                        <Input placeholder="输入邀请函备注信息" allowClear />
                    </Form.Item>

                    {/* <Form.Item
                    name="direct"
                    label="邀请函类型"
                    rules={[{ required: true, message: '' }]}
                    help="一人一码：任何人可查看邀请函，不登录；统一邀请码：仅限被邀请用户，手机号验证通过查看邀请，需登录 "
                >
                    <Radio.Group value={invitationType} onChange={handleRadioChange}>
                        <Radio value={3}>一人一码</Radio>
                        <Radio value={1}>统一邀请码</Radio>
                    </Radio.Group>
                </Form.Item> */}

                    <Form.Item name="expiration" label="有效期" rules={[{ required: true, message: '' }]} help="邀请函仅在有效期内，可提交邀请函反馈；超过有效期，用户可查看，但不可提交邀请函反馈。">
                        <RangePicker />
                    </Form.Item>

                    <Form.Item name="userTitle" label="邀请称呼" rules={[{ required: true, message: '' }]}>
                        <Select placeholder="选择邀请称呼">
                            <Select.Option key={1} value={1}>
                                无
                            </Select.Option>
                            <Select.Option key={2} value={2}>
                                先生/女士
                            </Select.Option>
                            <Select.Option key={3} value={3}>
                                教授
                            </Select.Option>
                            <Select.Option key={4} value={4}>
                                嘉宾
                            </Select.Option>
                            <Select.Option key={5} value={5}>
                                老师
                            </Select.Option>
                            <Select.Option key={6} value={6}>
                                专家职务
                            </Select.Option>
                        </Select>
                    </Form.Item>

                    <div className="form-subtitle">模块设置</div>

                    <Form.Item name="projectCardEnabled" label="项目官网" valuePropName="checked">
                        <Switch checkedChildren="显示" unCheckedChildren="隐藏" />
                    </Form.Item>

                    <Form.Item name="contentEnabled" label="启用邀请词" valuePropName="checked">
                        <Switch checkedChildren="启用" unCheckedChildren="关闭" onChange={onEnableContentSwitchChange} />
                    </Form.Item>

                    {(oneData.contentEnabled === 1 || onEnableContentSwitch) && (
                        <>
                            <Form.Item
                                name="invitationContent"
                                className="invitationContent"
                                label="邀请词内容"
                                rules={[
                                    { required: true, message: '' },
                                    {
                                        validator: async (rule, value) => {
                                            // 富文本内容判空
                                            // eg. 富文本内容：`<p><img src=""><br><img src=""><br/></p>`
                                            // '<p><img src=""><br><img src=""><br/></p>'?.replace(/<(img[^>]+)>/gi, '[$1]')?.replace(/<\/?[^>]+>/g, '')?.replace(/\[([^\]]+)\]/g, '<$1>')?.replace(/[ 　]+/g, '')
                                            // 先把 img tag 保护起来，然后把所有 tag 都移除，再把 img tag 还原，最后把空格移除。
                                            // 最终如果还是空，那说明富文本内容为空。
                                            if (!value || value === '') {
                                                throw '请输入邀请词内容';
                                            } else {
                                                const cleanValue = value
                                                    ?.replace(/<(img[^>]+)>/gi, '[$1]') // 保护img标签
                                                    ?.replace(/<\/?[^>]+>/g, '') // 移除所有HTML标签
                                                    ?.replace(/\[([^\]]+)\]/g, '<$1>') // 还原img标签
                                                    ?.replace(/[ 　]+/g, '') // 移除空格
                                                    ?.trim(); // 去除首尾空白

                                                if (!cleanValue || cleanValue === '') {
                                                    throw '请输入邀请词内容';
                                                }
                                            }
                                        },
                                    },
                                ]}
                            >
                                <RichEditor id="invitation-content" mode="full" value={prodDetails ?? ''} onChange={onProdDetailsChange} imageUploadHandler={imageUploadHandler} className="react-editor" />
                            </Form.Item>

                            <Form.Item
                                label={
                                    <>
                                        <span>邀请函落款</span>
                                        <PopoverTip
                                            placement="right"
                                            content={
                                                <>
                                                    <p>展示位置：电子邀请函邀请词落款处</p>
                                                    <img src="https://mediafiles.cn-healthcare.com/boss/popovertip/medconf_sig%402x.png" alt="" style={{ width: 600 }} />
                                                </>
                                            }
                                        >
                                            <i className="bi bi-question-circle-fill popover-tip-icon"></i>
                                        </PopoverTip>
                                    </>
                                }
                            >
                                <p style={{ paddingTop: 5, marginBottom: 4 }}>可为邀请词添加署名+日期的落款，署名最多添加3个，如不需要请留空，署名和日期均选填</p>
                                署名1：
                                <Form.Item name={['signature', 'sigs', 0]} style={{ marginBottom: 8 }}>
                                    <Input placeholder="输入落款署名" allowClear maxLength={30} showCount />
                                </Form.Item>
                                署名2：
                                <Form.Item name={['signature', 'sigs', 1]} style={{ marginBottom: 8 }}>
                                    <Input placeholder="输入落款署名" allowClear maxLength={30} showCount />
                                </Form.Item>
                                署名3：
                                <Form.Item name={['signature', 'sigs', 2]} style={{ marginBottom: 8 }}>
                                    <Input placeholder="输入落款署名" allowClear maxLength={30} showCount />
                                </Form.Item>
                                日期：
                                <Form.Item name={['signature', 'date']} style={{ marginBottom: 0 }}>
                                    <Input placeholder="输入落款日期，如 2025年6月9日" allowClear maxLength={15} style={{ width: 300 }} showCount />
                                </Form.Item>
                            </Form.Item>
                        </>
                    )}

                    <Form.Item label="附件" help="支持 JPG/PNG/PDF 文件格式，最多上传5个5MB以内的附件" className="upload-invations-form">
                        {fileList
                            && fileList.map((item, index) => (
                                <div className="doc_area" key={index}>
                                    <i className="bi bi-paperclip icon1" />
                                    <Form.Item name={['attachments', `path${index}`]} style={{ marginBottom: 0 }} className="path_area">
                                        <Input disabled />
                                    </Form.Item>

                                    <Form.Item name={['attachments', `name${index}`]} style={{ marginBottom: 0 }} rules={[{ required: true, message: '显示文件名不能为空' }]}>
                                        <Input onChange={e => changeFileName(e, index)} placeholder="请输入显示文件名" />
                                    </Form.Item>
                                    <i className="bi bi-trash icon1 delicon" onClick={() => changeFile(index, 'del')} />
                                    {index !== 0 && <i className="bi bi-arrow-up icon1" onClick={() => changeFile(index, 'up')} />}
                                    {index !== fileList.length - 1 && <i className="bi bi-arrow-down icon1" onClick={() => changeFile(index, 'down')} />}
                                </div>
                            ))}
                        <Upload beforeUpload={file => fileCheck(file, 5)} {...pdfFile} maxCount={5} fileList={fileList}>
                            <Button icon={<i className="bi bi-upload" />} disabled={fileList.length > 4}>
                                上传附件
                            </Button>
                        </Upload>
                    </Form.Item>

                    <Form.Item name="agenda" label="启用日程安排" valuePropName="checked">
                        <Switch checkedChildren="启用" unCheckedChildren="关闭" />
                    </Form.Item>

                    <Form.Item noStyle shouldUpdate>
                        {({ getFieldValue }) => {
                            return (
                                !!getFieldValue('agenda') && (
                                    <Form.Item name="unconfirmedExpertDisplayStatus" label="待确认邀请专家" valuePropName="checked">
                                        <Switch checkedChildren="显示" unCheckedChildren="隐藏" />
                                    </Form.Item>
                                )
                            );
                        }}
                    </Form.Item>

                    <Form.Item name="rightFormEnabled" label="启用权益形式" valuePropName="checked">
                        <Switch checkedChildren="启用" unCheckedChildren="关闭" onChange={onRightFormEnabledSwitchChange} />
                    </Form.Item>

                    {(oneData.rightFormEnabled === 1 || onRightFormSwitch) && (
                        <Form.Item label="权益形式" required>
                            <Form.List name="rightForm" className="projects-race-form-list">
                                {(fields, { add, remove }) => (
                                    <Fragment>
                                        <Form.Item style={{ marginBottom: 10 }}>
                                            <div style={{ color: '#00000073' }}>最多可勾选5个权益供用户选择</div>
                                        </Form.Item>

                                        {fields.map(({ key, name, ...restFields }, index) => (
                                            <div key={key} style={{ display: 'flex', marginBottom: 10 }}>
                                                <Form.Item {...restFields} name={[name, 'check']} style={{ marginBottom: 0 }} valuePropName="checked">
                                                    <Checkbox label="权益名称" style={{ marginRight: 20 }}></Checkbox>
                                                </Form.Item>
                                                <Form.Item
                                                    {...restFields}
                                                    name={[name, 'name']}
                                                    rules={[
                                                        {
                                                            required: true,
                                                            validator: async (rule, value) => {
                                                                if (form.getFieldValue('rightForm')[index].check && !value) {
                                                                    throw '权益名称不能为空';
                                                                }
                                                            },
                                                        },
                                                    ]}
                                                    style={{ marginBottom: 0 }}
                                                >
                                                    <Input placeholder="请输入" style={{ width: 400 }} disabled={index === 0} />
                                                </Form.Item>
                                            </div>
                                        ))}
                                    </Fragment>
                                )}
                            </Form.List>
                        </Form.Item>
                    )}

                    <Form.Item name="cocreationFormEnabled" label="启用意向选项" valuePropName="checked">
                        <Switch checkedChildren="启用" unCheckedChildren="关闭" onChange={onCocreationFormEnabledSwitchChange} />
                    </Form.Item>

                    {(oneData.cocreationFormEnabled === 1 || onCocreationFormSwitch) && (
                        <Form.Item label="意向选项" required>
                            <Form.List name="cocreationForm" className="projects-race-form-list">
                                {(fields, { add, remove }) => (
                                    <Fragment>
                                        <Form.Item style={{ marginBottom: 10 }}>
                                            <div style={{ color: '#00000073' }}>最多可勾选30个意向选项供用户选择</div>
                                        </Form.Item>

                                        {fields.map(({ key, name, ...restFields }, index) => (
                                            <div key={key} style={{ display: 'flex', marginBottom: 10 }}>
                                                <Form.Item {...restFields} name={[name, 'check']} style={{ marginBottom: 0 }} valuePropName="checked">
                                                    <Checkbox label="意向选项" style={{ marginRight: 20 }}></Checkbox>
                                                </Form.Item>
                                                <Form.Item
                                                    {...restFields}
                                                    name={[name, 'name']}
                                                    rules={[
                                                        {
                                                            required: true,
                                                            validator: async (rule, value) => {
                                                                if (form.getFieldValue('cocreationForm')[index].check && !value) {
                                                                    throw '意向选项不能为空';
                                                                }
                                                            },
                                                        },
                                                    ]}
                                                    style={{ marginBottom: 0 }}
                                                >
                                                    <Input placeholder="请输入" style={{ width: 400 }} />
                                                </Form.Item>
                                            </div>
                                        ))}
                                        {fields.length < 30 && (
                                            <Form.Item style={{ marginLeft: 20 }}>
                                                <Button
                                                    type="link"
                                                    onClick={() => {
                                                        // add();
                                                        const values = form.getFieldValue('cocreationForm');
                                                        const newValues = values.concat({ id: fields.length + 1, name: '', check: false });
                                                        // console.log(values, fields.length)
                                                        form.setFieldValue('cocreationForm', newValues);
                                                    }}
                                                >
                                                    添加
                                                </Button>
                                            </Form.Item>
                                        )}
                                    </Fragment>
                                )}
                            </Form.List>
                        </Form.Item>
                    )}

                    {/*<Form.Item name="confirmPersonalInfo" label="个人信息" valuePropName="checked">*/}
                    {/*    <Switch checkedChildren="显示" unCheckedChildren="隐藏" onChange={onConfirmPersonalInfoSwitchChange}/>*/}
                    {/*</Form.Item>*/}

                    {(oneData.userInfoEnabled === 1 || onConfirmPersonalInfoSwitch) && (
                        <Form.Item name="userFields" label="个人信息字段" rules={[{ required: true, message: '请勾选信息选项' }]}>
                            <UserFieldsCheckboxGroups baseList={baseList} moreList={moreList} />
                        </Form.Item>
                    )}

                    <Form.Item name="enableTips" label="启用温馨提示" valuePropName="checked">
                        <Switch checkedChildren="启用" unCheckedChildren="关闭" onChange={onEnableTipsSwitchChange} />
                    </Form.Item>
                    {oneData.tipsEnabled === 1 || onEnableTipsSwitch ? (
                        <Form.Item
                            name="tips"
                            label="温馨提示内容"
                            rules={[
                                { required: true, message: '' },
                                {
                                    validator: async (rule, value) => {
                                        if (isEffectivelyEmptyRichHtml(value)) {
                                            throw '请输入温馨提示内容';
                                        }
                                    },
                                },
                            ]}
                        >
                            <RichEditor id="invitation-tips" mode="full" value={topProdDetails ?? ''} onChange={onTopProdDetailsChange} imageUploadHandler={imageUploadHandler} className="react-editor" />
                        </Form.Item>
                    ) : null}

                    <Form.Item name="contactsEnabled" label="启用联系人" valuePropName="checked">
                        <Switch checkedChildren="启用" unCheckedChildren="关闭" onChange={onContactsEnabledSwitchChange} />
                    </Form.Item>

                    {(oneData.contactsEnabled === 1 || onEnableContactsSwitch) && (
                        <Form.Item label="联系人信息" required>
                            <Form.List name="contactInfos" className="projects-race-form-list">
                                {(fields, { add, remove }) => (
                                    <Fragment>
                                        <Form.Item style={{ marginBottom: 10 }}>
                                            <Button type="link" size="small" disabled={fields?.length >= 10} onClick={() => add()}>
                                                <i className="bi bi-plus-circle" /> 新增联系人
                                            </Button>
                                        </Form.Item>
                                        {fields.map(({ key, name, ...restFields }, index) => (
                                            <div key={key} className="invitation-form-list">
                                                <Form.Item {...restFields} name={[name, 'userName']} label="联系人" rules={[{ required: true, message: '请输入联系人姓名' }]}>
                                                    <Input placeholder="联系人姓名" style={{ width: 160 }} />
                                                </Form.Item>
                                                <Form.Item
                                                    {...restFields}
                                                    name={[name, 'phone']}
                                                    label="联系电话"
                                                    rules={[
                                                        { required: true, message: '请输入联系人电话' },
                                                        { pattern: /^1\d{10}$/, message: '电话格式不正确' },
                                                    ]}
                                                    className="input-phone"
                                                >
                                                    <Input placeholder="联系人电话" style={{ width: 160 }} />
                                                </Form.Item>

                                                {fields?.length > 1 && (
                                                    <div className="projects-icon-main">
                                                        <i className="bi bi-x-circle icon-pointer-projects" onClick={() => remove(name)}></i>
                                                    </div>
                                                )}
                                            </div>
                                        ))}
                                    </Fragment>
                                )}
                            </Form.List>
                        </Form.Item>
                    )}

                    <div className="form-subtitle">外观设置</div>

                    <Form.Item
                        name="shareTitle"
                        label="分享标题"
                        rules={[{ required: true, message: '分享标题不能为空' }]}
                        extra={
                            <>
                                <Text type="warning">如须在分享标题中体现专家姓名称谓，请将光标置于上方输入框合适的位置，点击</Text>
                                <Button type="link" size="small" onClick={insertNameTitleToShareTitle}>
                                    插入姓名称谓
                                </Button>
                            </>
                        }
                    >
                        <Input ref={inputShareTitleRef} value={shareTitle} onChange={changeShareTitle} showCount />
                    </Form.Item>

                    <Form.Item name="shareDesc" label="分享描述" rules={[{ required: true, message: '分享描述不能为空' }]}>
                        <Input showCount />
                    </Form.Item>

                    <Form.Item label="分享图" className="image-box" required help="支持JPG/PNG格式，尺寸300&times;300px，文件大小不超过1MB">
                        {!!oneData.shareImage && (
                            <div className="invationImg">
                                <Image width={200} src={getFileUrl(oneData.shareImage)} alt="分享图预览" />
                            </div>
                        )}
                        <Form.Item name="shareImage" noStyle rules={uploadImageRequiredRules} valuePropName="fileList" getValueFromEvent={normFile}>
                            <ImgCrop
                                aspect={1 / 1}
                                minZoom={0.1}
                                maxZoom={2}
                                quality={1}
                                beforeCrop={async file => {
                                    const res = await beforeCropCheck(file, true);
                                    return res;
                                }}
                            >
                                <Upload beforeUpload={file => checkout(file, 3, 300, 300)} {...shareImageFile} maxCount={1}>
                                    <Button icon={<i className="bi bi-upload" />}>{!!oneData.shareImage ? '更改图片' : '上传图片'}</Button>
                                </Upload>
                            </ImgCrop>
                        </Form.Item>
                    </Form.Item>

                    <Form.Item label="列表封面" className="image-box" required help="用于列表展示，支持JPG/PNG格式，建议尺寸 1500*844px（不小于 750*422px，比例16:9），文件大小不超过2MB">
                        {!!oneData.coverForList && (
                            <div className="invationImg">
                                <Image width={200} src={getFileUrl(oneData.coverForList)} alt="列表封面预览" />
                            </div>
                        )}
                        <Form.Item name="coverForList" noStyle rules={uploadImageRequiredRules} valuePropName="fileList" getValueFromEvent={normFile}>
                            <Upload beforeUpload={file => checkout(file, 2, 1500, 844)} {...coverForListFile} maxCount={1}>
                                <Button icon={<i className="bi bi-upload" />}>{!!oneData.coverForList ? '更改图片' : '上传图片'}</Button>
                            </Upload>
                        </Form.Item>
                    </Form.Item>

                    {/* {invitationType === 1 && (
                    <Form.Item
                        name="h5Cover"
                        label="H5封面图"
                        className='image-box'
                        rules={[
                            { required: true, message: '' }
                        ]}
                        help="支持JPG/PNG格式，尺寸750&times;1500px（版心700&times;1000px，其顶部距图片顶部50px），文件大小不超过1MB">
                        {!!oneData.h5CoverUrl && (
                            <div className='invationImg'><Image width={200} src={getFileUrl(oneData.h5CoverUrl)}/></div>
                        )}
                        <Upload beforeUpload={(file) => checkout(file, 1, 750, 1500)} {...h5CoverFile} maxCount={1}>
                            <Button icon={<i className="bi bi-upload" />}>{!!oneData.h5CoverUrl ? '更改图片' : '上传图片'}</Button>
                        </Upload>
                    </Form.Item>
                )} */}

                    <Form.Item label="邀请函背景" className="image-box" extra="图片尺寸宽750px高不小于1000px（版心距左右各30px、上300px），支持JPG/PNG格式，大小不超过2MB">
                        {!!oneData.backgroundImage && (
                            <div className="invationImg">
                                <Image width={200} src={getFileUrl(oneData.backgroundImage)} alt="邀请函背景预览" />
                                <span onClick={closeImg} className="close-img">
                                    <i className="bi bi-x-lg" />
                                </span>
                            </div>
                        )}

                        <Form.Item name="backgroundImage" noStyle valuePropName="fileList" getValueFromEvent={normFile}>
                            <Upload beforeUpload={file => checkout(file, 1, 750, 900)} {...backgroundImageFile} maxCount={1}>
                                <Button icon={<i className="bi bi-upload" />}>{!!oneData.backgroundImage ? '更改图片' : '上传图片'}</Button>
                            </Upload>
                        </Form.Item>
                    </Form.Item>

                    <div className="form-subtitle">导出邀请话术设置</div>
                    <div className="form-subtitle-desc">
                        <div className="form-subtitle-desc-item">1. 嘉宾姓名，系统会默认填充，示例：尊敬的 “嘉宾姓名”“邀请称呼”。</div>
                        <div className="form-subtitle-desc-item">2. 请在“管理邀请用户”模块操作导出邀请码，如果设置了邀请话术，则会按邀请话术内容导出。</div>
                    </div>

                    <Form.Item
                        name="invitationDesc"
                        label="邀请话术"
                        extra={
                            <>
                                <Text type="warning">如须在邀请话术中体现邀请链接，请将光标置于上方输入框合适的位置，点击</Text>
                                <Button type="link" size="small" onClick={handleInsert}>
                                    插入邀请链接
                                </Button>
                            </>
                        }
                    >
                        <Input.TextArea ref={textAreaRef} placeholder="示例：诚邀您参与本大会，我们为您安排了部分任务，点击 $邀请链接$ 进行确认，会务联系人 黄先生 18612015770" autoSize={{ minRows: 5 }} maxLength={500} value={textAreaValue} showCount onChange={handleTextAreaChange} />
                    </Form.Item>

                    <Form.Item name="btnarea" {...pageFormItemWithoutLabelGridLayout} style={{ marginTop: 24, marginBottom: 0 }}>
                        <Space size="large">
                            <Button type="primary" size="large" htmlType="submit">
                                提交
                            </Button>
                            {!id && (
                                <Button type="default" size="large" onClick={onReset}>
                                    取消
                                </Button>
                            )}
                        </Space>
                    </Form.Item>
                </Form>
            </div>
        </Fragment>
    );
}
